import { Button, Card, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import React from "react";

const CardMes = ({ setCuotasPrint , cuota, handleButtonPayed, father, handleButtonCuotaEfectivo }) => {
    const isPagado = cuota.status === "pagado";
    return (
        <Card className="mb-3" style={{
            border: "2px dashed #ccc",
            borderRadius: "12px",
            backgroundColor: "rgba(255, 255, 255, 0.01)",
            fontFamily: "'Courier New', Courier, monospace"
        }}>
            <Card.Header>
                <Row className="text-end">
                    <Col>
                    { isPagado &&                         <input
                            type="checkbox"
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setCuotasPrint(prev => {
                                if (checked) {
                                    return [...prev, cuota];
                                } else {
                                    return prev.filter(c => c.id !== cuota.id);
                                }
                                });
                                }}
                            className="w-10 h-10 rounded-md accent-green-500 cursor-pointer"
                            style={{width:'24px',height:'24px'}}
                        />}
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                        {cuota.mes.toUpperCase()}
                    </div>
                    <div className={`badge ${isPagado ? "bg-success" : "bg-danger"}`}>
                        {cuota.status==='pending'?'PENDIENTE':cuota.status.toUpperCase()}
                    </div>
                </div>

                <hr style={{ borderTop: "1px dashed #999" }} />
                <div>
                    <p>{!isPagado && "$ "+cuota.monto}</p>
                </div>

                <div className="text-end">
                    <Button
                        variant={isPagado ? "outline-secondary" : "outline-primary"}
                        size="sm"
                        onClick={() => handleButtonPayed(father.id, cuota.mes, cuota)}
                    >
                        {isPagado ? "Ver Ticket" : "Pagos Tic"}
                    </Button>
                    {!isPagado && 
                    <Button 
                        variant="outline-primary"
                        onClick={handleButtonCuotaEfectivo}
                    >
                        
                    {"Efectivo"}</Button>}
                </div>
            </Card.Body>
        </Card>
    );
};
CardMes.propTypes = {
    cuota: PropTypes.object.isRequired,
    handleButtonPayed: PropTypes.func.isRequired,
    father: PropTypes.object.isRequired,
    setCuotasPrint: PropTypes.func.isRequired,
    handleButtonCuotaEfectivo: PropTypes.func.isRequired
};

export default CardMes;
